/*
 * @Author: Niklaus
 * @Date: 2025-12-18 10:53:52
 * @LastEditTime: 2026-04-18 14:18:01
 * @LastEditors: Niklaus
 * @Description: 楼宇及房间自定义请求API
 */
import request from "@/router/axios";

/**
 * @Author: Niklaus
 * @Description: 作废房间（若有子房间，则一起作废）
 * @param {房间ID} id
 */
export const updateRoomStatus = (id) => {
  return request({
    url: `/api/park-spcod/room/customRemove/${id}`,
    method: "delete",
  });
};

export const batchUpdateRoomByImport = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return request({
    headers: {
      "Content-Type": "multipart/form-data",
    },
    url: "/api/park-company/room/updateImport",
    method: "post",
    data: formData,
  });
};
